import getFormData from './getFormData';
import calculatePrice from './calculatePrice';
import maybeDefault from './maybeDefault';

const Utils = { getFormData, calculatePrice, maybeDefault };

export default Utils;
